import api from './_api';
import Vue from 'vue'

const loadWarengruppen = async (context) => {
    try {
        var response = await api.fetchWarengruppen()                
        context.commit('WARENGRUPPEN_SET',response.data)        
        return response
    }
    catch(error) {                        
        return null
    };    
}

const loadTypes = async (context) => {
    try {
        var response = await api.fetchTypes()                
        context.commit('TYPES_SET',response.data)        
        return response
    }
    catch(error) {                        
        return null
    };    

}
export default {
    loadWarengruppen,
    loadTypes
};